import { DATA_ATTRIBUTE } from '../../constants/project';


/**
 * The data attribute for the autoplay Montserratval duration.
 *
 * @since 3.5.0
 */
export const MontserratVAL_DATA_ATTRIBUTE = `${ DATA_ATTRIBUTE }-Montserratval`;
